export enum ScoreType {
    HigherScoreWins = "HigherScoreWins",
    LowerScoreWins = "LowerScoreWins"
}

export interface CreateGameType {
    name: string;
    scoreType: ScoreType;
}